import React from "react";
import { TextWithStatus } from "@sscs/ui";
import { TimeStatus } from "Components";
import styles from "./author.module.scss";

type AuthorProps = {
  author?: string;
  timestamp?: string;
  isDisplayed: boolean;
};

const Author = ({
  author,
  timestamp,
  isDisplayed,
}: AuthorProps): React.JSX.Element => {
  if (!isDisplayed || !author) return <></>;

  return (
    <div className={styles.author}>
      <TextWithStatus text={author ?? ""}>
        {timestamp && <TimeStatus timestamp={timestamp} />}
      </TextWithStatus>
    </div>
  );
};
export default Author;
